import { defaultClient as ApolloClient } from "@/main";
import { GET_ALL_FACILITIES } from "@/graphql/facility/facilityQ";
import { FACILITY_MERGE, FACILITY_DELETE } from "@/graphql/facility/facilityM";

export const actions = {
  allFacility: async ({ commit }) => {
    return ApolloClient.query({
      query: GET_ALL_FACILITIES
    })
      .then(({ data }) => {
        commit("setFacilities", data.allFacility.edges);
      })
      .catch(err => {
        console.error(`Error in allFacility action. Full info => ${err}`);
      });
  },
  addFacility: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: FACILITY_MERGE,
      variables: payload,
      update: (cache, { data: { facilityMerge } }) => {
        try {
          const data = cache.readQuery({
            query: GET_ALL_FACILITIES
          });
          data.allFacility.edges.push(facilityMerge);
          cache.writeQuery({
            query: GET_ALL_FACILITIES,
            data
          });
        } catch (error) {
          console.error(
            `Error in addFacility update hook. Full info => ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allFacility");
      })
      .catch(error => {
        console.error(`Error in addFacility action. Full info => ${error}`);
      });
  },
  updateFacility: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: FACILITY_MERGE,
      variables: payload
    })
      .then(() => {
        dispatch("allFacility");
      })
      .catch(error => {
        console.error(`Error in addFacility action. Full info => ${error}`);
      });
  },
  removeFacility: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: FACILITY_DELETE,
      variables: payload,
      update: cache => {
        try {
          const data = cache.readQuery({
            query: GET_ALL_FACILITIES
          });
          data.allFacility.edges = data.allFacility.edges.filter(
            f => +f.node.facilityId !== payload.id
          );
          cache.writeQuery({
            query: GET_ALL_FACILITIES,
            data
          });
        } catch (error) {
          console.error(
            `Error in removeFacility update hook. Full info => ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allFacility");
      })
      .catch(error => {
        console.error(`Error in removeFacility action. Full info => ${error}`);
      });
  }
};
